namespace TabAurous.HR {
    export interface EmployeeAdvanceForm {
        EmployeeId: Serenity.IntegerEditor;
        LedgerId: Serenity.IntegerEditor;
        VoucherNo: Serenity.StringEditor;
        InvoiceNo: Serenity.StringEditor;
        Date: Serenity.DateEditor;
        Amount: Serenity.DecimalEditor;
        SalaryMonth: Serenity.DateEditor;
        Chequenumber: Serenity.StringEditor;
        ChequeDate: Serenity.DateEditor;
        Narration: Serenity.StringEditor;
        ExtraDate: Serenity.DateEditor;
        Extra1: Serenity.StringEditor;
        Extra2: Serenity.StringEditor;
        SuffixPrefixId: Serenity.DecimalEditor;
        VoucherTypeId: Serenity.DecimalEditor;
        FinancialYearId: Serenity.DecimalEditor;
        CompanyId: Serenity.DecimalEditor;
    }

    export class EmployeeAdvanceForm extends Serenity.PrefixedContext {
        static formKey = 'HR.EmployeeAdvance';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!EmployeeAdvanceForm.init)  {
                EmployeeAdvanceForm.init = true;

                var s = Serenity;
                var w0 = s.IntegerEditor;
                var w1 = s.StringEditor;
                var w2 = s.DateEditor;
                var w3 = s.DecimalEditor;

                Q.initFormType(EmployeeAdvanceForm, [
                    'EmployeeId', w0,
                    'LedgerId', w0,
                    'VoucherNo', w1,
                    'InvoiceNo', w1,
                    'Date', w2,
                    'Amount', w3,
                    'SalaryMonth', w2,
                    'Chequenumber', w1,
                    'ChequeDate', w2,
                    'Narration', w1,
                    'ExtraDate', w2,
                    'Extra1', w1,
                    'Extra2', w1,
                    'SuffixPrefixId', w3,
                    'VoucherTypeId', w3,
                    'FinancialYearId', w3,
                    'CompanyId', w3
                ]);
            }
        }
    }
}
